module.exports = __webpack_public_path__ + "static/img/Bitmap4@2x.f9470bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bitmap4@2x.png
// module id = QTxS
// module chunks = 1